import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { Container, Row, Col, Button, Modal, ToggleButton, ToggleButtonGroup } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import { useAuth } from '../../../components/auth/useAuth'
import { addUser, getUsers, editUser, enableUser, disableUser } from '../../../actions/usersActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'
import Swal from 'sweetalert2'
import Loader from '../../../components/loaders/Loader'
import UserForm from '../../../components/forms/UserForm'

export default function Users() {
    const { t } = useTranslation()
    const location = useLocation()
    const dispatch = useDispatch()
    const {clientauth} = useAuth()

    const {users, resultuser, loading, total} = useSelector(state=>state.users)

    const [modalShow, setModalShow] = useState(false)
    const [formState, setFormState] = useState({})
    const [isRegistering, setIsRegistering] = useState(false)
    const [isAddingOrEditing, setIsAddingOrEditing] = useState(false)
    const [filterActive, setFilterActive] = useState(true)

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(25)
    const [search, setSearch] = useState('')
    const [searchAux, setSearchAux] = useState('')
    const [sortField, setSortField] = useState('email')
    const [sortOrder, setSortOrder] = useState('asc')

    useEffect(() => {
        if(clientauth){
            dispatch(getUsers(page, limit, search, sortField, sortOrder, filterActive))
        }
    // eslint-disable-next-line
    }, [dispatch, clientauth, page, limit, search, sortField, sortOrder, filterActive])

    const openModal = () =>{
        setIsAddingOrEditing('adding')
        setFormState({
            username: '',
            email: '',
            password: '',
            rol: 'Secretary'
        })
        setModalShow(true)
    }

    const selectUser = (user) => {
        setIsAddingOrEditing('editing')
        setFormState(user)
        setModalShow(true)
    }

    const handleSort = (column, sortDirection) => {
        setSortField(column.id || 'email')
        setSortOrder(sortDirection)
        setPage(1)
    }

    const handleInputChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.value
        })
    }

    const handleCheckboxChange = ({target})=>{
        setFormState({
            ...formState,
            [target.name]: target.checked
        })
    }

    const handleSubmit= async(e) => {
        e.preventDefault()
        setIsRegistering(true)

        if(isAddingOrEditing==='editing'){
            dispatch(editUser(formState, formState._id))
        }else{
            dispatch(addUser(formState))
        }
        setIsRegistering(false)
    }

    const disableEnableUsers = async(e) => {
        e.preventDefault()
        let textQuestion = ''
        formState.active
            ?
                textQuestion = t('admin.users.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.username+'</label></p>'
            :
                textQuestion = t('admin.users.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+formState?.username+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: t('global.accept'),
            cancelButtonText: t('global.cancel'),
            icon: 'question',
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (formState.active) {
                    dispatch(disableUser(formState._id))
                }else{
                    dispatch(enableUser(formState._id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultuser){
            let resultuserTemp = resultuser
            dispatch({ type: 'USER_RESET_RESULT'})
            switch (resultuserTemp) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.addsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successedit':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.editsuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successenable':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.enablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                case 'successdisable':
                    Swal.fire({
                        showConfirmButton: true,
                        showCancelButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.users.disablesuccess')
                    }).then(() => {
                        setModalShow(false)
                        setIsAddingOrEditing(false)
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultuser])

    const columnsUsers = [
        {
            id: 'email',
            name: t('admin.users.email'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.email}
                </div>,
            selector: (user) => user.email,
            sortable: true,
        },{
            id: 'username',
            name: t('admin.users.username'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {user.username}
                </div>,
            selector: (user) => user.username,
            sortable: true,
        },{
            id: 'rol',
            name: t('admin.users.rol'),
            cell: user =>
                <div className='cursor' onClick={() => selectUser(user)}>
                    {t('admin.users.'+user.rol)}
                </div>,
            selector: (user) => user.rol,
            sortable: true,
        },{
            id: 'active',
            name: t('admin.users.active'),
            width: '200px',
            cell: user =>
                <div>
                    {user.active
                        ?
                            <img src="../images/check.svg" alt="check" width={25}></img>
                        :
                            <img src="../images/times.svg" alt="times" width={25}></img>
                    }
                </div>,
            selector: (user) => user.active,
            sortable: true,
        },{
            name: '',
            width: '200px',
            center: true,
            cell: user =>
                <>
                    <div className='cursor me-3' onClick={() => selectUser(user)}>
                        <i className='fas fa-pencil'></i>
                    </div>
                </>,
            sortable: false,
        }
    ]

    const filteredUsers = users

    return (
        <Container className='mt-5 px-0'>
            <Row>
                <Col xs={12} className='text-center'>
                    <h1>
                        {filterActive
                            ?
                            t('admin.users.usersenabled')
                            :
                            t('admin.users.usersdisabled')
                        }
                    </h1>
                </Col>
                <Col xs={6} className='d-flex justify-content-start'>
                    <ToggleButtonGroup
                        type="radio"
                        name="filterActive"
                        value={filterActive}
                        onChange={(value) => { setFilterActive(value); setPage(1) }}
                    >
                        <ToggleButton id="tbg-active" value={true} variant={filterActive === true ? "primary" : "outline-secondary"}>
                            {t('admin.users.enabled')}
                        </ToggleButton>
                        <ToggleButton id="tbg-inactive" value={false} variant={filterActive === false ? "primary" : "outline-secondary"}>
                            {t('admin.users.disabled')}
                        </ToggleButton>
                    </ToggleButtonGroup>
                </Col>
                <Col xs={6} className='d-flex justify-content-end'>
                    <Button variant='primary' type="submit" className="my-2 cursor" onClick={() => openModal()}>
                        {t('admin.users.createuser')}
                    </Button>
                </Col>
            </Row>
            {loading && !users ?
                <Loader/>
            :
                <Row>
                    <Col>
                        <div className="d-flex my-2">
                            <input
                                type="text"
                                className="form-control me-2"
                                placeholder={t("datatables.buscar")}
                                value={searchAux || ""}
                                onChange={e => {
                                    setSearchAux(e.target.value);
                                    setPage(1);
                                }}
                                onKeyDown={(e) => {if (e.key === 'Enter') { setSearch(searchAux); setPage(1); }}}
                            />
                            <Button onClick={() => setSearch(searchAux)}><i className='fas fa-search'></i></Button>
                        </div>
                        {filteredUsers?.length > 0 ?
                            <CustomDataTable
                                columns={columnsUsers}
                                data={filteredUsers}
                                pagination
                                paginationServer
                                paginationTotalRows={total}
                                paginationPerPage={limit}
                                progressPending={loading}
                                sortServer
                                onSort={handleSort}
                                defaultSortField={sortField}
                                defaultSortAsc={sortOrder !== 'desc'}
                                exportable={false}
                                printable={false}
                                onChangeRowsPerPage={(newLimit) => {
                                    setLimit(newLimit)
                                    setPage(1)
                                }}
                                onChangePage={(newPage) => {
                                    setPage(newPage)
                                }}
                            />
                        :
                            <h4 className='mt-4'>{t('admin.users.thereisnotusers')}</h4>
                        }
                    </Col>
                </Row>
            }
            <Modal
                show={modalShow}
                onHide={() => setModalShow(false)}
                aria-labelledby="contained-modal-title-vcenter"
                size="lg"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        <h2>{t('admin.users.users')}</h2>
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <UserForm
                        state={formState}
                        handleInputChange={handleInputChange}
                        handleCheckboxChange={handleCheckboxChange}
                        submit={handleSubmit}
                        disableEnableUsers={disableEnableUsers}
                        isAddingOrEditing={isAddingOrEditing}
                        isRegistering={isRegistering}
                    />
                </Modal.Body>
            </Modal>
        </Container>
    )
}